import(/* webpackMode: "eager" */ "/app/apps/pickleball/src/app/error.tsx");
